import reactotronConfig from './shared/reactotronConfig/reactotronConfig';

import rootReducer from './reducers';
import rootSaga from './sagas/index';

const store = reactotronConfig(rootReducer, rootSaga);

export default () => {
    if (process.env.NODE_ENV !== 'production' && module.hot) {
        module.hot.accept('./reducers', () => store.replaceReducer(rootReducer));
    }
    return { store };
};
